<template>
  <helmi-group-dashboard-card
    :initializing="initializing"
    class="helmi-group-dashboard-offices"
    title="Valitse asuntomyymälät"
    theme-switch
    use-theme
  >
    <v-row
      no-gutters
    >
      <v-col
        cols="12"
        class="px-4"
      >
        <v-chip-group
          v-model="selectedOfficeIndexes"
          active-class="primary white--text"
          class="mb-4"
          column
          multiple
        >
          <v-chip
            v-for="office in offices"
            :key="office.company_id"
            small
          >
            {{ office.name }}
          </v-chip>
        </v-chip-group>

        <v-btn
          rounded
          x-small
          outlined
          color="primary"
          class="mb-4"
          @click="toggleAll()"
        >
          {{ selectedOffices.length !== offices.length ? 'Valitse kaikki' : 'Poista valinnat' }}
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        class="px-4"
      >
        <v-select
          v-model="year"
          :items="years"
          :dark="theme ==='dark'"
          class="mb-5"
          label="Vuosi"
          solo
          dense
          hide-details
          @change="setChartYear(year)"
        />
      </v-col>
    </v-row>
  </helmi-group-dashboard-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { apiGet } from '../../api';

export default {
  name: 'GroupDashboardOfficeSelector',

  components: {
    'helmi-group-dashboard-card': () => import('@/components/groupDashboard/GroupDashboardCard'),
  },

  props: {
    colors: {
      type: Array,
      default: new Array(5),
    },
  },

  data: () => ({
    year: new Date().getFullYear(),
    selectedOffices: [],
    selectedOfficeIndexes: [],
    initializing: true,
    offices: [],
    processingData: false,
  }),

  computed: {
    ...mapState({
      theme: 'theme',
    }),
    years() {
      return Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);
    },
  },

  watch: {
    selectedOfficeIndexes: {
      async handler(value) {
        this.selectedOffices = value.map(office => this.offices[office]);
        this.setGroupCompanies(this.selectedOffices);
      },
      deep: true,
      immediate: true,
    },
  },

  async mounted() {
    await this.initialize();
  },

  methods: {
    ...mapActions({
      setGroupCompanies: 'setGroupCompanies',
      setChartYear: 'setChartYear',
    }),
    /**
     * Gets the offices from an endpoint
     */
    async getOffices() {
      const response = await apiGet('reporting/group-companies');
      this.offices = response.result.map((item) => {
        let { name } = item;

        if (response.result.filter(i => i.name === name).length > 1) {
          name = `${item.name} (${item.company_id})`;
        }

        return {
          company_id: item.company_id,
          name,
          phone: item.phone,
          address: item.address,
          city: item.city,
          email: item.email,
        };
      });
      this.selectedOffices = [...this.offices];
      this.selectedOfficeIndexes = this.offices.map((item, index) => index);
      this.setGroupCompanies(this.selectedOffices);
    },

    toggleAll() {
      if (this.offices.length !== this.selectedOffices.length) {
        this.selectedOfficeIndexes = this.offices.map((item, index) => index);
      } else {
        this.selectedOfficeIndexes = [];
      }
    },

    async initialize() {
      await this.getOffices();
      this.initializing = false;
    },
  },
};
</script>

<style lang="scss"></style>
